import React, { useState } from "react";
import {
  Select,
  Input,
  Button,
  Card,
  Typography,
  message,
  Col,
  Row,
} from "antd";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { Bookmark, BookmarkCheck, BookmarkMinus, Plus } from "lucide-react";
import InputField from "@/components/InputField";
import Dropdown from "@/components/Dropdown";
import { useQuery } from "react-query";
import superuserService from "@/services/superadminService";
import Dropdown1 from "@/components/Dropdown1";
import userService from "@/services/userService";
import ControlledCheckbox from "@/components/ControlledCheckbox";
import DynamicInput from "@/components/DynamicForm";

const { Title, Text } = Typography;

// NestedField component
const NestedField = ({ nestIndex, control, watch ,setValue}) => {
  const { fields } = useFieldArray({
    control,
    name: `tour_fields.${nestIndex}.tablename`,
  });

  return (
    <div
      className="d-flex flex-row gap-3 overflow-auto"
      style={{ maxWidth: "100%", whiteSpace: "nowrap" }}
    >
      {fields.map((item, k) => (
        <div
          key={item.id}
          className="border rounded-3 p-3 mb-3 "
          style={{ width: "200px", flex: "0 0 auto" }}
        >
          <InputField
            disabled={true}
            name={`tour_fields.${nestIndex}.tablename.${k}.field_name`}
            control={control}
            placeholder="Field Name"
          />

          <InputField
            control={control}
            name={`tour_fields.${nestIndex}.tablename.${k}.field_type`}
            disabled={true}
            placeholder="FieldType"
          />

          <Controller
            name={`tour_fields.${nestIndex}.tablename.${k}.description`}
            control={control}
            render={({ field }) => (
              <Input.TextArea {...field} placeholder="Description" />
            )}
          />
          <div className="w-100 mt-3">
            <DynamicInput
              name={`tour_fields.${nestIndex}.tablename.${k}.defaultValue`}
              control={control}
              type={watch(`tour_fields.${nestIndex}.tablename.${k}.field_type`)}
              setValue ={setValue}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

const TourManager = () => {
  const { data: createdTours } = useQuery({
    queryKey: ["tourlist"],
    queryFn: () => superuserService.getalltour(),
  });
  const [isupdate, setIsUpdate] = useState(false);
  const [isTourList, setIsTourList] = useState(true);
  const { data } = useQuery({
    queryKey: ["eventlists"],
    queryFn: () => superuserService.getAllEvents(),
  });
  const { control, handleSubmit, reset, setValue, watch } = useForm({
    defaultValues: {
      tour_name: "",
      event_name: "",
      reportType: "",
      activate: "",
      tour_fields: [
        {
          tablename: [
            {
              table_name: "",
              field_name: "",
              field_type: "",
              description: "",
              defaultValue: "",
            },
          ],
        },
      ],
    },
  });

  const { fields: tourFields } = useFieldArray({
    control,
    name: "tour_fields",
  });

  const fetchData = async (data) => {
    try {
      const response = data;
          console.log("tableGroup[tableName]",response)

      const groupedFields = [];

      response.tableDescriptions.forEach((tableGroup) => {
        Object.keys(tableGroup).forEach((tableName) => {
          const fields = tableGroup[tableName].map((fieldObj) => ({
            table_name: tableName,
            field_name: fieldObj.name,
            field_type: fieldObj.type,
            description: "",
            defaultValue: "",
          }));
          groupedFields.push({
            tablename: fields,
          });
        });
      });

      setValue("tour_fields", groupedFields);
    } catch (error) {
      console.error("Error fetching table data:", error);
      message.error("Failed to load table data");
    }
  };

  const onSubmit = async (data) => {
      const newTours = [];

    data.tour_fields.forEach((group) => {
      group.tablename.forEach((field) => {
        if (field.table_name && field.field_name) {
          newTours.push({
            tour_name: data.tour_name,
            event_name: data.event_name,
            ...field,
          });
        }
      });
    });

    if (isupdate) {
      await superuserService.updatetour({
        tour_name: data.tour_name,
        event_name: data.event_name,
        reportType: data.reportType,

        activate: data.activate,
        tour_fields: data.tour_fields,
      });
      message.success("Tour updated successfully!");
    } else {
      await superuserService.createTour({
        tour_name: data.tour_name,
        event_name: data.event_name,
        reportType: data.reportType,

        activate: data.activate,
        tour_fields: data.tour_fields,
      });

      message.success("Tour created successfully!");
    }
    reset({
      tour_name: "",
      event_name: "",
      tour_fields: [
        {
          tablename: [
            {
              table_name: "",
              field_name: "",
              field_type: "",
              description: "",
              defaultValue: "",
            },
          ],
        },
      ],
    });
    setIsTourList(false);
  };

  const transformApiData = (data) => {
    return data.flatMap((entry) =>
      Object.entries(entry).map(([table_name, fields]) => ({
        tablename: fields.map((field) => ({
          table_name, // 👈 inject table_name into each field
          ...field,
        })),
      }))
    );
  };

  const onviewTour = async (tname, event, reportType, activate) => {
    console.log("event",event)
    const eventdata = await superuserService.gettour(tname);
    console.log("eventdata", eventdata);
    setValue("tour_name", tname);
    setValue("event_name", event);
 
    setValue("reportType", reportType);
    setValue("activate", activate);

    const transformed = transformApiData(eventdata?.data);
    console.log("transformed", transformed);

    setValue("tour_fields", transformed);
    setIsUpdate(true);
    setIsTourList(false);
  };
  return isTourList ? (
    <>
      <div className="d-flex justify-content-between mx-3 mt-2">
        <Typography.Title level={4} className="mb-4 mt-2 ">
          Tours Management
        </Typography.Title>
        <Button type="primary" onClick={() => setIsTourList(false)}>
          Create New Tour
        </Button>
      </div>
      <Row gutter={16}></Row>
      <Row gutter={16}>
        {createdTours?.data.length > 0 ? (
          createdTours?.data?.map(
            ({ tour_name, event_name, reportType, activate }, key) => (
              <Col
                span={6}
                key={key}
                onClick={() =>{
                    console.log("event_name",event_name)
                  onviewTour(tour_name, event_name, reportType, activate)
                
                }
                }
              >
                <Card className="text-center">
                  <div
                    className="rounded-4 d-flex justify-content-end  ms-auto bg-secondary p-1"
                    style={{ width: "40%" }}
                  >
                    <span className="fs-12 mt-0 text-white me-3">
                      {reportType}
                    </span>
                    {activate ? (
                      <BookmarkCheck
                        size={20}
                        className="float-end text-white"
                      />
                    ) : (
                      <BookmarkMinus
                        size={20}
                        className="float-end text-white"
                      />
                    )}
                  </div>
                  <Typography.Title level={4} className="text-center mt-3">
                    {tour_name}
                  </Typography.Title>
                  <p className="text-center text-muted ">{event_name}</p>
                </Card>
              </Col>
            )
          )
        ) : (
          <Col span={24}>
            <p>No tours created yet. Click below to create your first tour.</p>
          </Col>
        )}
      </Row>
    </>
  ) : (
    <div className="mt-2">
      <div className="d-flex justify-content-between mb-3">
        <div>
          <Title level={4}>Tour Manager</Title>
          <Text type="secondary">
            Create and manage tour descriptions for your application
          </Text>
        </div>
        <Button type="primary" onClick={() => setIsTourList(true)}>
          Back to Tour List
        </Button>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Card className="mb-4">
          <div className="mb-3 d-flex gap-3">
            <InputField
              className="w-25"
              name="tour_name"
              control={control}
              label={"Tour Name"}
              placeholder="Tour Name"
              rules={{ required: "Tour name is required" }}
            />
            <Dropdown1
              className="w-25"
              label={"Event Name"}
              name="event_name"
              control={control}
              options={data?.data?.map((x) => ({
                value: x?.event_type,
                label: x?.event_type,
              }))}
              onChange={async (e) => {
                console.log("ee", e);

                const geteventname = data?.data?.find(
                  (x) => x?.event_type === e
                )?.event_type;
                const eventdata = await userService.getModulesforUser(
                  geteventname
                );
                fetchData(eventdata);
                console.log("event", eventdata.tableDescriptions);
              }}
              rules={{ required: "Event name is required" }}
            />

            <Dropdown1
              className="w-25"
              label={"Report Type"}
              name="reportType"
              control={control}
              options={[
                {
                  label: "DAILY_REPORT",
                  value: "DAILY_REPORT",
                },
                {
                  label: "MONTHLY_REPORT",
                  value: "MONTHLY_REPORT",
                },
                {
                  label: "WEEKLY_REPORT",
                  value: "WEEKLY_REPORT",
                },
                {
                  label: "BUNKER_INVENTORY",
                  value: "BUNKER_INVENTORY",
                },
              ]}
            />
            <ControlledCheckbox
              name="activate"
              control={control}
              label={"Activate"}
            />
          </div>

          {tourFields.map((field, index) => (
            <div key={field.id} className="mb-4 border rounded-3 p-3">
              <Typography.Title level={5}>
                {field?.tablename[0]?.table_name || ""}
              </Typography.Title>
              <NestedField nestIndex={index} control={control} watch={watch} setValue={setValue} />
            </div>
          ))}

          <div className="d-flex justify-content-end">
            <Button type="primary" htmlType="submit">
              Create Tour Description
            </Button>
          </div>
        </Card>
      </form>
    </div>
  );
};

export default TourManager;
